
<script>
    import { onMount } from "svelte";
    import Chart from "chart.js/auto";
    import ChartDataLabels from "chartjs-plugin-datalabels";

    let chart;

    const tokenomicsData = [
        { name: "Airdrop", description: "XaMiner/RelayerXM AirDrop", percentage: 11 },
        { name: "Growth", description: "Marketing, Promos, & Giveaways", percentage: 14 },
        { name: "Liquidity", description: "Locked", percentage: 75 },
    ];

    const labels = tokenomicsData.map(item => item.name);
    const data = tokenomicsData.map(item => item.percentage);
    const descriptions = tokenomicsData.map(item => item.description);

    onMount(() => {
        const ctx = document.getElementById("tokenomicsChart").getContext("2d");

        if (chart) {
            chart.destroy();
        }

        chart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.6)',
                        'rgba(255, 99, 132, 0.6)',
                        'rgba(75, 192, 192, 0.6)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)',
                        'rgba(75, 192, 192, 1)'
                    ],
                    borderWidth: 2,
                }]
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: {
                            font: {
                                size: 14
                            },
                            color: '#333'
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                const index = tooltipItem.dataIndex;
                                return `${descriptions[index]}: ${data[index]}%`;
                            }
                        }
                    },
                    datalabels: {
                        color: '#fff',
                        font: {
                            weight: 'bold',
                            size: 16
                        },
                        formatter: (value) => `${value}%`
                    }
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            },
            plugins: [ChartDataLabels]
        });
    });
</script>

<section>
    <h2>Tokenomics Distribution</h2>
    <p>Here is a high-level overview of how the tokenomics are structured for launch</p>
    <div class="chart-container">
        <canvas id="tokenomicsChart"></canvas>
    </div>
    <p>Total Supply: 1,000,000,000 Tokens</p>
    <p>75% of Supply Locked in LP on Meteora</p>
</section>

<style>
    .chart-container {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
        padding: 10px;
    }

    #tokenomicsChart {
        width: 100%;
        height: auto;
    }

    section {
        min-height: 100vh; /* Full viewport height */
        display: flex;
        flex-direction: column;
        justify-content: center; /* Centers content vertically */
        align-items: center; /* Centers content horizontally */
        padding: 2rem;
        text-align: center;
    }

    h2 {
        font-size: 1.8rem;
        margin-bottom: 1rem;
    }

    p {
        font-size: 18pt;
        line-height: 1.5;
        margin-bottom: 1.5rem;
    }

    label {
        font-size: 1rem;
    }

    input[type="number"] {
        width: 80px;
        padding: 0.3rem;
        font-size: 1rem;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    button {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    button:hover {
        background-color: #0056b3;
    }
</style>
